import { useCallback } from "react";

export function useScrollToElement() {
  const scrollToElement = useCallback((elementId: string): void => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, []);

  return scrollToElement;
}